<template>
  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 pl-0 pr-0">
    <skeleton-screen v-if="!dataLoaded"></skeleton-screen>

    <div
      v-if="dataLoaded"
      class="col-md-12 col-sm-12 col-lg-12 col-xl-12 baise yuanjiao pb-3 gundt mb-3 mrt"
      style="font-size: calc(7px + 0.4vw); border-radius: 12px 12px 12px 12px"
    >
      <empty v-if="show"></empty>
      <div v-if="!show">
        <div class="d-flex align-items-center pt-3 mb-3">
          <img
            v-if="dataLoaded"
            @click="fanhui(0)"
            class="curpo dcbd mr-3"
            style="width: calc(25px + 0.4vw)"
            src="@/img/login/icon_fanhui@2x.png"
            alt=""
          />
          <div class="curpo sjbzt">{{ name }} - {{ $t("资金用途") }}</div>
        </div>
        <!-- <div class="col-md-12 yinc mb-3 pl-0 pr-0 yuanjiao d-flex justify-content-between align-items-center text-center " style="background: #FFFAF0;">
          <div class="col-md-2 col-sm-1 col-lg-2 col-xl-2 p-3 yuanjiao" style="width:calc(150px + 0.4vw);">
            {{ $t('zzssyt') }}
          </div>
          <div class="col-md-2 col-sm-2 col-lg-2 col-xl-1 pl-0 pr-0 text-center">{{ $t('ytmc') }}</div>
          <div class="col-md-3 col-sm-3 col-lg-2 col-xl-2 pl-0 pr-0" style="text-align: center !important">
            {{ $t('zjytxxjs') }}
          </div>
          <div class="col-md-1 col-sm-2 col-lg-2 col-xl-1 text-center pl-0 pr-0">
            {{ $t('syjjsl') }}
          </div>
          <div class="col-md-1 col-sm-2 col-lg-2 col-xl-2 text-center pl-0 pr-0">
            {{ $t('riqi') }}
          </div>
        </div> -->
        <div
          v-for="(item, index) in list"
          :key="index"
          class="bbb col-md-12 mb-3 pl-0 p-3 yuanjiao d-flex"
          style="background: #f6f4f0; flex-wrap: wrap"
          :ref="'listItem_' + index"
          id="'listItem_' + index"
        >
          <div class="content_img_box yuanjiao" style="margin-right: 1%">
            <div
              class="ml-2 d-flex curpo text-center"
              @click="showMedia(0, item.image)"
              style="position: relative; align-items: center"
            >
              <img
                style="
                  border-radius: 5%;
                  height: calc(180px + 0.4vw);
                  object-fit: cover;
                  width: 100%;
                  z-index: 99;
                "
                :src="item.image[0]"
                alt=""
                mode="widthFix"
              />
              <div
                style="
                  background: #000000;
                  opacity: 0.3;
                  width: 100%;
                  height: calc(180px + 0.4vw);
                  position: absolute;
                  z-index: 100;
                  text-align: center;
                  border-radius: 5%;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  color: #ffeab8;
                  z-index: 101;
                  text-align: center;
                  width: 100%;
                  font-weight: 600;
                "
              >
                +{{ item.image.length }}
              </div>
            </div>
          </div>
          <div
            style="
              width: 75%;
              height: 100%;
              padding: 3px 0 0 2px;
              position: relative;
            "
          >
            <div class="d-flex mb-3" style="justify-content: space-between">
              <div
                class=""
                style="flex: 1; font-weight: 600; font-size: calc(10px + 0.4vw)"
              >
                {{ item.title }}
              </div>
              <div
                class="col-md-1 col-sm-2 col-lg-2 col-xl-2 pl-0 pr-0"
                style="
                  color: #000;
                  text-align: right;
                  font-size: calc(8px + 0.4vw);
                "
              >
                <span class="mr-3">NT${{ item.amount }}</span>
                <span>{{ timeFilter(item.create_time) }}</span>
              </div>
            </div>
            <div
              class="mb-3"
              style="
                text-align: left;
                color: #666666;
                font-size: calc(6px + 0.4vw);
              "
              v-html="item.content"
            ></div>
            <div class="clearBox"></div>
            <div class="operBox">
              <div class="operBoxLeft">
                <button
                  class="yuanjiao ckqbb curpo annys operBtn d-flex"
                  style="background: #1877f2; align-items: center"
                  @click="clickShare(item)"
                >
                  <img
                    src="@/img/donation/icon_grzx_facebook@2x.png"
                    style="width: calc(15px + 0.4vw); object-fit: cover"
                    alt=""
                  />
                  分享到Facebook
                </button>
                <button
                  class="yuanjiao ckqbb curpo annys operBtn d-flex"
                  style="background: #22ba4f; align-items: center"
                >
                  <img
                    src="@/img/donation/icon_grzx_line@2x.png"
                    style="width: calc(15px + 0.4vw); object-fit: cover"
                    alt=""
                  />
                  分享到LINE
                </button>
                <div
                  class="operBoxLeftLike d-flex"
                  style="align-items: center"
                  @click="clickLike(item)"
                >
                  <img
                    src="@/img/donation/icon_weidianzan.png"
                    v-if="item.is_praise == 0"
                    class="mr-1"
                    style="
                      width: calc(12px + 0.4vw);
                      height: calc(12px + 0.4vw);
                      align-items: center;
                    "
                    alt=""
                  />
                  <img
                    src="@/img/donation/icon_hssy_xh_twotwo.png"
                    v-else
                    class="mr-1"
                    style="
                      width: calc(12px + 0.4vw);
                      height: calc(12px + 0.4vw);
                      align-items: center;
                    "
                    alt=""
                  />
                  <span style="color: #666666; font-size: calc(8px + 0.4vw)">{{
                    item.donation_use_praise_count || 0
                  }}</span>
                </div>
              </div>
              <div class="operBoxRight">
                <button
                  class="yuanjiao ckqbb curpo annys operBtn d-flex"
                  style="
                    background: #ffebd2;
                    align-items: center;
                    color: #1a1a1a;
                  "
                  @click="clickPL(item, index)"
                >
                  <img
                    src="@/img/donation/icon_pl@2x.png"
                    class="mr-2"
                    style="width: calc(10px + 0.4vw); object-fit: cover"
                    alt=""
                  />
                  查看{{ item.donation_use_comments_count }}則評論
                  <img
                    src="@/img/donation/icon_xq@2x.png"
                    class="ml-2"
                    style="width: calc(3px + 0.4vw); object-fit: cover"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
          <div
            class="mt-3 mb-3 pt-1 pl-2"
            style="
              width: 100%;
              font-size: calc(8px + 0.4vw);
              color: #666666;
              font-weight: 600;
              border-top: 1px solid #e5e5e5;
            "
            v-if="expandedCommentIndex === index"
          >
            評論區
          </div>
          <div
            class="comment-expand-area"
            v-if="expandedCommentIndex === index"
          >
            <!-- 评论列表 -->
            <div class="comment-expand-area-list">
              <div
                class="comment-expand-area-list-item mb-3"
                v-for="(v, i) in item.donation_use_comments"
                :key="i"
              >
                <div class="comment-expand-area-list-item-left">
                  <img
                    :src="v.avatar"
                    style="
                      width: calc(30px + 0.4vw);
                      height: calc(30px + 0.4vw);
                      border-radius: 50%;
                    "
                    alt=""
                  />
                </div>
                <div class="comment-expand-area-list-item-right">
                  <div class="comment-expand-area-list-item-right-name">
                    <span
                      class="mr-2"
                      style="color: #1a1a1a; line-height: calc(30px + 0.4vw)"
                      >{{ v.nickname }}</span
                    ><span style="color: #999999">{{ v.create_time }}</span>
                  </div>
                  <div class="comment-expand-area-list-item-right-content">
                    {{ v.content }}
                  </div>
                </div>
              </div>
              <empty
                v-if="item.donation_use_comments.length == 0"
                style="position: relative; top: -2vh"
              ></empty>
            </div>
            <div class="comment-expand-area-clear"></div>
            <div class="comment-expand-area-input">
              <img
                style="
                  width: calc(25px + 0.4vw);
                  height: calc(25px + 0.4vw);
                  border-radius: 50%;
                "
                :src="
                  user.avatar || '@/img/daohangl/pic_hssy_zdh_touxiang@2x.png'
                "
                class="mr-2 ml-2"
                alt=""
              />
              <input
                style="
                  background: #f6f4f0;
                  border: none;
                  font-size: calc(7px + 0.4vw);
                "
                v-model="commentText"
                :disabled="isLoading"
                type="name"
                class="sjbxzt form-control srk pl-3"
                placeholder="分享一下"
              />
              <button
                class="yuanjiao ckqbb curpo annys operBtn d-flex mr-2 ml-2"
                :disabled="isLoading"
                style="background: #ffd672; align-items: center"
                @click="clickSend(item, index)"
              >
                <img
                  src="@/img/daohangl/btn_hssy_fbtw@2x.png"
                  style="
                    border: none;
                    width: calc(15px + 0.4vw);
                    height: calc(15px + 0.4vw);
                  "
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>

        <div v-if="isFullscreen" class="fullscreen-modal">
          <template>
            <img
              :src="mediaList[currentIndex]"
              alt="fullscreen"
              class="fullscreen-image"
            />
          </template>
          <img
            class="curpo"
            @click="prevMedia(currentIndex)"
            style="
              width: calc(30px + 0.5vw);
              height: calc(30px + 0.5vw);
              position: absolute;
              left: 5%;
              top: 50%;
            "
            src="@/img/daohangl/cb19415c55cd84d9d1ec84d64975476.png"
          />
          <img
            class="curpo"
            @click="nextMedia"
            style="
              width: calc(30px + 0.5vw);
              height: calc(30px + 0.5vw);
              position: absolute;
              right: 5%;
              top: 50%;
            "
            src="@/img/daohangl/450d77812abbc1eeb69e7b12b85d1b2.png"
          />
          <img
            class="curpo"
            @click="closeFullscreen"
            style="
              width: calc(30px + 0.5vw);
              height: calc(30px + 0.5vw);
              position: absolute;
              right: 5%;
              top: 5%;
            "
            src="@/img/details/cha.png"
          />
          <div
            class="thumbnail-container pb-3 yinc"
            style="width: 80%; overflow-x: auto"
          >
            <div class="d-flex" style="gap: 10px">
              <img
                v-for="(image, index) in mediaList"
                :key="index"
                :src="image"
                :class="{ selected: currentIndex === index }"
                @click="currentIndex = index"
                alt="缩略图"
                :style="{
                  border: currentIndex === index ? '2px solid #ffd672' : '',
                }"
              />
            </div>
          </div>
          <div
            class="thumbnail-containers pb-3 aaaa"
            style="width: 80%; overflow-x: auto"
          >
            <div class="d-flex" style="gap: 10px">
              <img
                v-for="(image, index) in mediaList"
                :key="index"
                :src="image"
                :class="{ selected: currentIndex === index }"
                @click="currentIndex = index"
                alt="缩略图"
                :style="{
                  border: currentIndex === index ? '2px solid #ffd672' : '',
                }"
              />
            </div>
          </div>
        </div>
        <!-- 手机版 -->
        <div
          v-for="(item, index) in list"
          :key="index"
          class="aaaa mb-3 yuanjiao p-3"
          style="background: #f6f4f0"
        >
          <div>
            <div class="sjbzt" style="font-weight: 600">{{ item.title }}</div>
            <div
              class="mt-3 mb-3"
              style="background: #e5e5e5; height: 1px"
            ></div>
            <div class="d-flex justify-content-between mb-1">
              <div
                class="text-center pl-0 pr-2 sjbzt"
                style="
                  width: 50%;
                  text-align: left !important;
                  font-weight: 600;
                "
              >
                {{ $t("riqi") }}
              </div>
              <div
                class="text-center pl-0 pr-0 sjbzt"
                style="
                  width: 50%;
                  text-align: left !important;
                  font-weight: 600;
                "
              >
                {{ $t("syjjsl") }}
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div
                class="text-center pl-0 pr-2 sjbxzt"
                style="
                  width: 50%;
                  text-align: left !important;
                  font-weight: 600;
                "
              >
                {{ timeFilter(item.create_time) }}
              </div>
              <div
                class="text-center pl-0 pr-0 sjbxzt"
                style="
                  font-weight: 600;
                  width: 50%;
                  text-align: left !important;
                "
              >
                NT$
                {{ item.amount }}
              </div>
            </div>
            <div class="sjbzt mt-3 mb-1" style="font-weight: 600">
              {{ $t("zjytxxjs") }}
            </div>
            <div class="sjbxzt mb-3" v-html="item.content"></div>
            <div class="sjbzt mb-2" style="font-weight: 600">
              {{ $t("zzssyt") }}
            </div>
            <div>
              <div
                class="ml-2 d-flex curpo text-center"
                @click="showMedia(0, item.image)"
                style="position: relative; align-items: center"
              >
                <img
                  style="
                    border-radius: 5%;
                    height: calc(120px + 0.4vw);
                    object-fit: cover;
                    width: calc(120px + 0.4vw);
                    z-index: 99;
                  "
                  :src="item.image[0]"
                  alt=""
                  mode="widthFix"
                />
                <div
                  style="
                    background: #000000;
                    opacity: 0.3;
                    width: calc(120px + 0.4vw);
                    height: calc(120px + 0.4vw);
                    position: absolute;
                    z-index: 100;
                    text-align: center;
                  "
                ></div>
                <div
                  class="sjbxzt"
                  style="
                    position: absolute;
                    color: #ffeab8;
                    z-index: 101;
                    text-align: center;
                    width: calc(120px + 0.4vw);
                    font-weight: 600;
                  "
                >
                  +{{ item.image.length }}
                </div>
              </div>
            </div>
          </div>
          <div class="clearBoxs"></div>
          <div class="operBoxs">
            <div class="operBoxLeft">
              <!-- <button  class="yuanjiao ckqbb curpo annys operBtn d-flex" style="background: #1877F2;align-items: center;" @click="clickShare(item)">
                  <img src="@/img/donation/icon_grzx_facebook@2x.png" style="width:calc(15px + 0.4vw);object-fit: cover" alt="">
                  分享到Facebook
                </button>
                <button  class="yuanjiao ckqbb curpo annys operBtn d-flex" style="background: #22BA4F;align-items: center;">
                  <img src="@/img/donation/icon_grzx_line@2x.png"  style="width:calc(15px + 0.4vw);object-fit: cover" alt="">
                  分享到LINE
                </button> -->
              <div
                class="operBoxLeftLike d-flex"
                style="align-items: center"
                @click="clickLike(item)"
              >
                <img
                  src="@/img/donation/icon_weidianzan.png"
                  v-if="item.is_praise == 0"
                  class="mr-1"
                  style="
                    width: calc(12px + 0.4vw);
                    height: calc(12px + 0.4vw);
                    align-items: center;
                  "
                  alt=""
                />
                <img
                  src="@/img/donation/icon_hssy_xh_twotwo.png"
                  v-else
                  class="mr-1"
                  style="
                    width: calc(12px + 0.4vw);
                    height: calc(12px + 0.4vw);
                    align-items: center;
                  "
                  alt=""
                />
                <span style="color: #666666; font-size: calc(10px + 0.4vw)">{{
                  item.donation_use_praise_count || 0
                }}</span>
              </div>
              <button
                class="yuanjiao ckqbb curpo annys operBtn d-flex ml-2"
                style="
                  background: #ffebd2;
                  align-items: center;
                  color: #1a1a1a;
                  font-size: calc(10px + 0.4vw);
                "
                @click="clickPL(item, index)"
              >
                <img
                  src="@/img/donation/icon_pl@2x.png"
                  class="mr-1"
                  style="width: calc(12px + 0.4vw); height: calc(12px + 0.4vw)"
                  alt=""
                />
                {{ item.donation_use_comments_count }}
              </button>
            </div>
            <div class="operBoxRight"></div>
          </div>
          <div
            class="mt-3 mb-3 pt-1 pl-2"
            style="
              width: 100%;
              font-size: calc(12px + 0.4vw);
              color: #666666;
              font-weight: 600;
              border-top: 1px solid #e5e5e5;
            "
            v-if="expandedCommentIndex === index"
          >
            評論區
          </div>
          <div
            class="comment-expand-area"
            v-if="expandedCommentIndex === index"
          >
            <!-- 评论列表 -->
            <div class="comment-expand-area-lists">
              <div
                class="comment-expand-area-list-item mb-3"
                v-for="(v, i) in item.donation_use_comments"
                :key="i"
              >
                <div class="comment-expand-area-list-item-left">
                  <img
                    :src="v.avatar"
                    style="
                      width: calc(30px + 0.4vw);
                      height: calc(30px + 0.4vw);
                      border-radius: 50%;
                    "
                    alt=""
                  />
                </div>
                <div class="comment-expand-area-list-item-right">
                  <div class="comment-expand-area-list-item-right-names">
                    <span
                      class="mr-2"
                      style="color: #1a1a1a; line-height: calc(30px + 0.4vw)"
                      >{{ v.nickname }}</span
                    ><span style="color: #999999">{{ v.create_time }}</span>
                  </div>
                  <div class="comment-expand-area-list-item-right-content">
                    {{ v.content }}
                  </div>
                </div>
              </div>
              <empty
                v-if="item.donation_use_comments.length == 0"
                style="position: relative; top: -2vh"
              ></empty>
            </div>
            <div class="comment-expand-area-clear"></div>
            <div class="comment-expand-area-input">
              <img
                style="
                  width: calc(25px + 0.4vw);
                  height: calc(25px + 0.4vw);
                  border-radius: 50%;
                "
                :src="
                  user.avatar || '@/img/daohangl/pic_hssy_zdh_touxiang@2x.png'
                "
                class="mr-2 ml-2"
                alt=""
              />
              <input
                style="
                  background: #f6f4f0;
                  border: none;
                  font-size: calc(7px + 0.4vw);
                "
                v-model="commentText"
                :disabled="isLoading"
                type="name"
                class="sjbxzt form-control srk pl-3"
                placeholder="分享一下"
              />
              <button
                class="yuanjiao ckqbb curpo annys operBtn d-flex mr-2 ml-2"
                :disabled="isLoading"
                style="background: #ffd672; align-items: center"
                @click="clickSend(item, index)"
              >
                <img
                  src="@/img/daohangl/btn_hssy_fbtw@2x.png"
                  style="
                    border: none;
                    width: calc(15px + 0.4vw);
                    height: calc(15px + 0.4vw);
                  "
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div
          v-if="list.length == 0"
          style="margin-top: 15vh; margin-bottom: 10vh"
        >
          <empty></empty>
        </div>
      </div>
      <div
        v-if="showImage"
        class="curpo"
        style="position: fixed; right: 5%; bottom: 10%"
      >
        <img
          @click="scrollToSection('zhixingld')"
          style="width: calc(36px + 0.4vw); height: calc(36px + 0.4vw)"
          src="@/img/icon_hssy_zhiding@2x.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/views/event-bus.js";
import empty from "../../empty/empty.vue";
import {
  todonation,
  donate_like,
  donate_unlike,
  used_comment,
} from "../../../request/jkhd/jkhd";
import { formatTimestamp, setSEO, shareTo } from "@/utils/common.js";
import SkeletonScreen from "./SkeletonScreen/zzsySkeletonScreen.vue";
import { buildWebUploadsUrl } from "@/utils/apiConfig";
export default {
  components: {
    SkeletonScreen,
    empty,
  },
  // seo相关代码,缺少app_id,获取后打开使用
  // metaInfo() {
  //   return {
  //     title: this.seoTitle,
  //     meta: [
  //       { property: 'og:title', content: this.seoTitle },
  //       { property: 'og:description', content: this.seoDescription },
  //       { property: 'og:image', content: this.seoImage }
  //     ]
  //   };
  // },
  data() {
    return {
      showImage: false, // 是否显示图片
      dataLoaded: false,
      list: [],
      page: 1,
      show: false,
      isLoadMore: false,
      limit: "",
      name: "",
      mediaList: [],
      currentIndex: null,
      currentMediaType: "",
      isFullscreen: "",
      expandedCommentIndex: null, // 控制评论是否展开
      commentText: "",
      isLoading: false,
      seoTitle: "这是自定义标题",
      seoDescription: "这是自定义内容",
      seoImage: buildWebUploadsUrl(
        "groups/1013/donation/%E4%B8%80%E6%A2%9D%E5%9C%8D%E5%B7%BE%E7%9A%84%E9%87%8D%E9%87%8F%EF%BC%8C%E8%AE%93%E5%86%AC%E5%A4%A9%E5%A4%9A%E4%B8%80%E4%BB%BD%E6%BA%AB%E6%9A%96/378b77e5ab2c93bb9c4417b18db7ae3e.jpg"
      ),
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getdonation();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async setPageSEO(item = null) {
      // return new Promise((resolve) => {
      // const seoData = {
      //   title: item ? item.title : this.name,
      //   description: item ? this.stripHtmlTags(item.content) : this.list[0] ? this.stripHtmlTags(this.list[0].content) : '',
      //   image: item ? item.image[0] : this.list[0] ? this.list[0].image[0] : '',
      //   url: window.location.href
      // };
      const seoData = {
        title: "这是自定义title",
        description: "这是自定义内容",
        image:
          buildWebUploadsUrl("groups/1013/donation/%E4%B8%80%E6%A2%9D%E5%9C%8D%E5%B7%BE%E7%9A%84%E9%87%8D%E9%87%8F%EF%BC%8C%E8%AE%93%E5%86%AC%E5%A4%A9%E5%A4%9A%E4%B8%80%E4%BB%BD%E6%BA%AB%E6%9A%96/378b77e5ab2c93bb9c4417b18db7ae3e.jpg"),
        url: `${window.location.origin}${this.$route.path}?id=${item.id}`,
      };

      // console.log(seoData , '这是seo的数据')
      // this.seoTitle = seoData.title;
      // this.seoDescription = seoData.description;
      // this.seoImage = seoData.image;

      // // 手动更新DOM meta标签
      // this.updateMetaTags();
      // this.$meta().refresh();

      // // 添加服务器端渲染提示
      // document.head.insertAdjacentHTML('beforeend', `
      //   <meta name="prerender-status-code" content="200">
      //   <meta name="prerender-header" content="X-Meta-Title: ${seoData.title}">
      // `);
      // 调用通用SEO设置
      setSEO({
        ...seoData,
        keywords: "公益,ESG,社会贡献", // 添加关键词
        type: "article", // 更精确的内容类型
      });
    },

    popupwindow(url) {
      return window.open(
        "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(url),
        "_blank",
        "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350"
      );
    },

    updateMetaTags() {
      // 增强选择器列表
      const metaSelectors = [
        'meta[name="description"]',
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[property="og:image"]',
        'meta[property="og:url"]',
        'meta[property="og:type"]', // 新增
        'meta[property="og:updated_time"]', // 新增
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]',
        'meta[name="twitter:image"]',
        'meta[name="twitter:url"]', // 新增
      ];

      // 触发DOM重排（关键）
      document.head.offsetHeight;

      // 创建标签逻辑优化
      const createTag = (name, content) => {
        const tag = document.createElement("meta");
        const isOg = name.startsWith("og:");
        tag.setAttribute(isOg ? "property" : "name", name);
        tag.setAttribute("content", content);
        tag.setAttribute("data-dynamic", "true"); // 新增追踪标记
        return document.head.appendChild(tag);
      };

      // 新增缓存破坏参数
      const cacheBuster = `?t=${Date.now()}`;
      const finalImageUrl = `${this.seoImage}${
        this.seoImage.includes("?") ? "&" : "?"
      }${cacheBuster}`;

      // 创建顺序优化（保持OG属性连续）
      createTag("og:title", this.seoTitle);
      createTag("og:description", this.seoDescription);
      createTag("og:image", finalImageUrl); // 使用带缓存破坏的URL
      createTag("og:url", window.location.href);
      createTag("og:type", "website"); // 新增必要属性
      createTag("og:updated_time", new Date().toISOString());
      createTag("twitter:title", this.seoTitle);
      createTag("twitter:description", this.seoDescription);
      createTag("twitter:image", this.seoImage);

      // 添加Facebook专用标记
      createTag("fb:app_id", "YOUR_APP_ID"); // 替换为实际App ID
      createTag("og:updated_time", new Date().toISOString());
    },

    stripHtmlTags(html) {
      if (!html) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },

    getAbsoluteImageUrl(url) {
      if (!url) return "";
      // 确保URL是绝对路径
      if (url.startsWith("http")) return url;
      // 处理相对路径
      return `${window.location.origin}${
        url.startsWith("/") ? url : `/${url}`
      }`;
    },

    // async clickShare(item) {
    //   console.log(item , '这是使用seo前传递的参数')
    //   await this.setPageSEO(item);

    //   // 等待SEO设置完成
    //   // const success = await this.setPageSEO(item);
    //   // if (!success) {
    //   //   this.$bvToast.toast('分享数据准备失败', {
    //   //     variant: 'danger',
    //   //     autoHideDelay: 5000
    //   //   });
    //   //   return;
    //   // }

    //   // 确保分享时使用最新的meta数据
    //   // shareTo("facebook", {
    //   //   url: window.location.href,
    //   //   title: item.title,
    //   //   description: this.stripHtmlTags(item.content),
    //   //   image: item.image[0]
    //   // });

    //   // 4. 打印调试信息
    //   await this.$nextTick(); // 等待DOM更新
    //    // 2. 强制触发vue-meta更新
    //   this.$meta().refresh();
    //   // 强制重新抓取
    //   const shareUrl = `${window.location.href.split('?')[0]}?t=${Date.now()}`;
    //   const forceFetch = `https://graph.facebook.com/?id=${encodeURIComponent(shareUrl)}&scrape=true&access_token=APP_ID|APP_SECRET`;
    //   fetch(forceFetch).then(() => {
    //     // 3. 添加时间戳避免缓存
    //     // 使用Facebook调试器API强制抓取
    //     const debugUrl = `https://developers.facebook.com/tools/debug/?q=${encodeURIComponent(shareUrl)}&force=true`;
    //     window.open(debugUrl, '_blank');
    //     console.log('当前meta标签:', {
    //       title: document.title,
    //       ogTitle: document.querySelector('meta[property="og:title"]')?.content,
    //       ogImage: document.querySelector('meta[property="og:image"]')?.content
    //     });
    //     // 添加调试信息
    //     console.log('SEO数据已更新:', {
    //       title: this.seoTitle,
    //       image: this.seoImage
    //     });

    //     setTimeout(() => {
    //       shareTo("facebook", {
    //         url: shareUrl,
    //         title: this.seoTitle,
    //         description: this.seoDescription,
    //         image: this.seoImage
    //       });
    //     }, 3000);
    //   });

    // },

    async clickShare(item) {
      // 强制更新URL参数
      // const shareUrl = `${window.location.href}?id=${item.id}&_t=${Date.now()}`;
      // history.replaceState({}, '', shareUrl);
      // console.log(item , 'item点击')
      // // 双保险SEO设置
      // setSEO({
      //   title: item.title,
      //   description: this.stripHtmlTags(item.content),
      //   image: item.image?.[0],
      //   url: shareUrl
      // });

      // // 混合分享方案
      // setTimeout(() => {
      //   window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`);
      // }, 300); // 留出DOM更新时间
      this.popupwindow(API_ENDPOINTS.INDEX_HTML);
    },

    // async clickShare(item) {
    //   // 暂时缺少Facebook API密钥及对应分享平台的app_id,以下代码可以正常分享跳转，但无法动态更改
    //   // return ;
    //   // 生成唯一URL并更新历史记录
    //   const shareUrl = `${window.location.origin}${this.$route.path}?id=${item.id}&_=${Date.now()}`;
    //   window.history.replaceState({}, document.title, shareUrl);

    //   // Fallback 1: 即时插入静态meta标签
    //   document.head.insertAdjacentHTML('afterbegin', `
    //     <meta property="og:url" content="${shareUrl}" data-fallback="1">
    //     <meta property="og:title" content="${item.title}" data-fallback="1">
    //     <meta property="og:description" content="${this.stripHtmlTags(item.content)}" data-fallback="1">
    //     <meta property="og:image" content="${item.image[0]}?t=${Date.now()}" data-fallback="1">
    //   `);

    //   // Fallback 2: 创建临时重定向页面
    //   const fallbackIframe = document.createElement('iframe');
    //   fallbackIframe.srcdoc = `
    //     <!DOCTYPE html>
    //     <html>
    //       <head>
    //         <meta http-equiv="refresh" content="0; url=${shareUrl}">
    //         ${document.head.innerHTML}
    //       </head>
    //     </html>
    //   `;
    //   document.body.appendChild(fallbackIframe);

    //   // Fallback 3: 基础SEO设置
    //   await this.setPageSEO(item);
    //   this.updateMetaTags();

    //   // Fallback 4: 最终分享逻辑
    //   try {
    //     // 方法1: 使用Facebook官方分享URL
    //     window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');

    //     // 方法2: 保留现有API调用
    //     await fetch(`https://graph.facebook.com/v18.0/?id=${encodeURIComponent(shareUrl)}&scrape=true`);

    //   } catch (error) {
    //     // 终极回退方案
    //     location.href = `https://www.facebook.com/dialog/share?app_id=APP_ID&display=popup&href=${encodeURIComponent(shareUrl)}`;
    //   } finally {
    //     // 清理临时元素
    //     setTimeout(() => {
    //       fallbackIframe.remove();
    //       document.querySelectorAll('[data-fallback="1"]').forEach(el => el.remove());
    //     }, 5000);
    //   }
    // },

    clickLike(item) {
      if (item.is_praise == 0) {
        donate_like({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.getdonation();
          } else {
            this.$bvToast.toast(this.$t("點贊失敗"), {
              title: "請檢查網絡",
              variant: "danger",
              autoHideDelay: 5000,
            });
          }
        });
      } else {
        donate_unlike({ id: item.id }).then((res) => {
          if (res.code == 200) {
            this.getdonation();
          } else {
            this.$bvToast.toast(this.$t("取消點贊失敗"), {
              title: "請檢查網絡",
              variant: "danger",
              autoHideDelay: 5000,
            });
          }
        });
      }
    },
    clickSend(item, index) {
      this.isLoading = true;
      used_comment({ id: item.id, content: this.commentText }).then((res) => {
        if (res.code == 200) {
          this.getdonation();
          this.commentText = "";
        } else {
          this.$bvToast.toast(this.$t("發表評論失敗"), {
            title: "請檢查網絡",
            variant: "danger",
            autoHideDelay: 5000,
          });
        }
        this.isLoading = false;
      });
    },
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    },
    clickPL(item, index) {
      if (this.expandedCommentIndex === index) {
        this.expandedCommentIndex = null;
      } else {
        this.expandedCommentIndex = index;
        this.$nextTick(() => {
          const element = this.$refs[`listItem_${index}`][0];
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },
    nextMedia() {
      if (this.currentIndex < this.mediaList.length - 1) {
        this.currentIndex++;
        this.currentMediaType = this.mediaList[this.currentIndex].type;
      }
    },
    closeFullscreen() {
      this.isFullscreen = false;
    },
    prevMedia() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.currentMediaType = this.mediaList[this.currentIndex].type;
      }
    },
    showMedia(index, v) {
      console.log(v);
      this.mediaList = v;
      this.currentIndex = index;
      // this.currentMediaType = this.mediaList[index].type;
      this.isFullscreen = true;
    },
    // 时间转换
    timeFilter(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    handleScroll(event) {
      const scrollTop = window.scrollY; // 页面滚动条距离顶部的距离
      const clientHeight = window.innerHeight; // 可见区域高度
      const scrollHeight = document.documentElement.scrollHeight; // 页面内容总高度
      if (scrollTop > clientHeight) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        if (!this.isLoadMore) {
          //此处判断，上锁，防止重复请求
          this.isLoadMore = true;
          this.page += 1;
          this.getdonation();
        }
      }
    },
    getdonation() {
      const data = {
        page: this.page,
        id: this.$route.params.zjsy,
      };
      todonation(data).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dataLoaded = true;
          this.name = res.data.name;
          this.limit = res.data.per_page;
          if (res.data.total == 0) {
            this.ishow = true;
          } else {
            this.ishow = false;
          }
          if (this.page * this.limit >= res.data.total) {
            if (this.page == 1) {
              this.list = res.data.data;
            } else {
              this.list.push(...res.data.data);
            }
            this.isLoadMore = true;
          } else {
            this.list.push(...res.data.data);
            this.isLoadMore = false;
          }
          // seo初始化代码
          // if (res.data.data && res.data.data.length > 0) {
          //       this.setPageSEO();
          //   }
        }
      });
    },
    fanhui(e) {
      this.$router.go(-1);
      // if (this.$route.params.judge == 1) {
      //   this.$router.push("/donation/" + this.$route.params.zjsy);
      //   EventBus.$emit("tthdfhs", "1");
      // } else {
      //   this.$router.push("/donation");
      // }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .asdasd {
    width: calc(60px + 0.4vw) !important;
    height: calc(60px + 0.4vw) !important;
  }
  .aaaa {
    display: block !important;
  }
  .bbb {
    display: none !important;
  }
}

@media screen and (max-width: 991px) {
  .mrt {
    margin-top: 1rem !important;
  }
  .heggs {
    height: 75vh !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .yinc {
    display: none !important;
  }
  .topg {
    margin-top: 1rem !important;
  }
}
.aaaa {
  display: none;
}
.bbb {
  display: block;
}
.content_img_box {
  width: 21%;
  height: calc(180px + 0.4vw);
}

.clearBox {
  width: 100%;
  height: calc(22px + 0.4vw + 1vh);
}
.clearBoxs {
  width: 100%;
  height: calc(22px + 0.4vw);
}

.operBox {
  position: absolute;
  bottom: 1vh;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.operBoxs {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.operBoxLeft {
  display: flex;
  align-items: center;
}

.operBtn {
  padding: 5px 9px;
  border-radius: 5px;
  margin-right: 0.5vw;
  color: #ffffff;
  font-family: Source Han Sans;
  font-size: calc(4px + 0.4vw);
  border: none;
}

.operBoxLeftLike {
  cursor: pointer;
}

.comment-expand-area {
  width: 100%;
  padding: 5px;
  margin-top: 10px;
  border-radius: 5px;
  transition: all 2s ease;
  max-height: 50vh;
}

.comment-expand-area-list {
  width: 100%;
  max-height: 40vh;
  width: 100%;
  margin-top: 10px;
  transition: all 0.3s ease;
  min-height: 40vh;
  overflow-y: auto; /* 添加滚动条 */
  display: flex;
  flex-direction: column-reverse; /* 内容从底部开始 */
}
.comment-expand-area-lists {
  width: 100%;
  max-height: 40vh;
  width: 100%;
  margin-top: 10px;
  transition: all 0.3s ease;
  min-height: 30vh;
  overflow-y: auto; /* 添加滚动条 */
  display: flex;
  flex-direction: column-reverse; /* 内容从底部开始 */
}

.comment-expand-area-clear {
  width: 100%;
}

.comment-expand-area-input {
  width: 100%;
  height: calc(50px + 0.4vw);
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
}

.comment-expand-area-list-item {
  display: flex;
  padding: 0.5vh;
}
.comment-expand-area-list-item-left {
  width: calc(40px + 0.4vw);
  display: flex;
  justify-content: center;
  margin-right: 0.5vw;
}
.comment-expand-area-list-item-left img {
  /* 圖片樣式 */
}
.comment-expand-area-list-item-right {
  /* 評論右側內容樣式 */
}
.comment-expand-area-list-item-right-name {
  font-size: calc(6px + 0.4vw);
  margin-bottom: 0.5vh;
}
.comment-expand-area-list-item-right-names {
  font-size: calc(10px + 0.4vw);
  margin-bottom: 0.5vh;
}
.comment-expand-area-list-item-right-content {
  padding: 1.5vh 2vh;
  background: #ffffff;
  border-radius: 12px;
  width: auto !important;
  font-size: calc(8px + 0.4vw);
}

.comment-expand-area-list-item-right-content {
  padding: 1.5vh 2vh;
  background: #ffffff;
  border-radius: 12px;
  width: auto !important;
  font-size: calc(10px + 0.4vw);
}

.widtshh {
  width: calc(10px + 0.4vw);
}

.thumbnail-container::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 滚动条高度（横向滚动条时） */
}

.thumbnail-container::-webkit-scrollbar-thumb {
  background: #ffd672; /* 滚动条滑块颜色 */
  border-radius: 4px; /* 滑块圆角 */
}

.thumbnail-container::-webkit-scrollbar-thumb:hover {
  background: #ffd672; /* 滑块悬停时颜色 */
}

.thumbnail-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道颜色 */
  border-radius: 4px; /* 轨道圆角 */
}

.dcbd:hover {
  transform: scale(1.06);
}
.gundt::-webkit-scrollbar {
  display: none;
}
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.fullscreen-image {
  max-width: 90%;
  max-height: 55%;
}

.thumbnail-container {
  position: fixed;
  bottom: 5%;
}

.thumbnail-container img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: transform 0.2s, border-color 0.2s;
}
.thumbnail-containers {
  position: fixed;
  bottom: 5%;
}

.thumbnail-containers img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  border-radius: 4px;
  transition: transform 0.2s, border-color 0.2s;
}
</style>
